module.exports = __webpack_public_path__ + "static/comission-2-3b8602a2c8cc7833228d997a5a6d4402.mp4";